/**
 * Contact Email Section Component
 * Displays contact email with show/hide functionality
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';

export interface ContactEmailSectionProps {
  contactEmail: string | null | undefined;
  showContactEmail: boolean;
  onShowContactEmail: () => void;
}

const linkBtn =
  'inline-block mt-2 text-xs text-jc-accent hover:text-jc-cta-hover underline px-2 py-1 border border-jc-accent/25 rounded-lg hover:bg-jc-accent-muted/40 cursor-pointer transition-colors';

export const ContactEmailSection: React.FC<ContactEmailSectionProps> = ({
  contactEmail,
  showContactEmail,
  onShowContactEmail,
}) => {
  if (!contactEmail) return null;

  if (!showContactEmail) {
    return (
      <button type="button" className={linkBtn} onClick={onShowContactEmail}>
        <FormattedMessage id="jobDetailPage.showContact" defaultMessage="Show Contact Email" description="Button label to reveal contact email address" />
      </button>
    );
  }

  return (
    <a
      href={`mailto:${contactEmail}`}
      className="inline-block mt-2 text-xs text-jc-accent hover:text-jc-cta-hover underline"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FormattedMessage id="jobDetailPage.contact" defaultMessage="Contact:" description="Label prefix for contact email address" /> {contactEmail}
    </a>
  );
};
